/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { HydratedIntegrationWriteObject } from './HydratedIntegrationWriteObject';
import {
    HydratedIntegrationWriteObjectFromJSON,
    HydratedIntegrationWriteObjectFromJSONTyped,
    HydratedIntegrationWriteObjectToJSON,
} from './HydratedIntegrationWriteObject';

/**
 * 
 * @export
 * @interface HydratedIntegrationWrite
 */
export interface HydratedIntegrationWrite {
    /**
     * 
     * @type {Array<HydratedIntegrationWriteObject>}
     * @memberof HydratedIntegrationWrite
     */
    objects?: Array<HydratedIntegrationWriteObject>;
}

/**
 * Check if a given object implements the HydratedIntegrationWrite interface.
 */
export function instanceOfHydratedIntegrationWrite(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function HydratedIntegrationWriteFromJSON(json: any): HydratedIntegrationWrite {
    return HydratedIntegrationWriteFromJSONTyped(json, false);
}

export function HydratedIntegrationWriteFromJSONTyped(json: any, ignoreDiscriminator: boolean): HydratedIntegrationWrite {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'objects': !exists(json, 'objects') ? undefined : ((json['objects'] as Array<any>).map(HydratedIntegrationWriteObjectFromJSON)),
    };
}

export function HydratedIntegrationWriteToJSON(value?: HydratedIntegrationWrite | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'objects': value.objects === undefined ? undefined : ((value.objects as Array<any>).map(HydratedIntegrationWriteObjectToJSON)),
    };
}

